import { makeStyles } from "tss-react/mui"
import { Entity } from "../supportEntitiesTypes"
import { MRT_Row } from "material-react-table"
import { Chip, Typography, Box, Stack } from "@mui/material"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    entityNameCellTitle: {
        color: tailwindPalette.sky[500],
        transition: "all ease-in-out 0.3s",
        "&:hover": {
            color: tailwindPalette.sky[800],
        },
        cursor: "pointer",
        fontWeight: 500,
        fontSize: ".875rem",
        textDecoration: "none",
    },
    entityNameCellSubtitle: {
        color: tailwindPalette.slate[500],
        fontSize: ".75rem",
    },
    entityNameCellSubtitleIcon: {
        color: tailwindPalette.slate[300],
        fontSize: ".25rem",
    },
    entityNameChip: {
        borderRadius: ".25rem",
        fontWeight: 500,
        height: "1.25rem",
        fontSize: ".625rem",
        border: `1px solid ${tailwindPalette.slate[500]}`,
        backgroundColor: "transparent",
        color: tailwindPalette.slate[700],
    },
}))

type EntityTableNameCellProps = {
    row: MRT_Row<Entity>
    onNameClick: () => void
}

export function EntityTableNameCell({ row, onNameClick }: EntityTableNameCellProps) {
    const { classes } = useStyles()

    return (
        <Box>
            <Stack direction="column" spacing="0.75rem">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box onClick={onNameClick} className={classes.entityNameCellTitle}>
                        <Typography>{row.original.name}</Typography>
                    </Box>
                    {row.original.alerts.length > 0 &&
                        row.original.alerts.map((alert, index) => (
                            <Chip key={index} label={alert.value} className={classes.entityNameChip} />
                        ))}
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    {row.original?.caseNumber && (
                        <>
                            <LocalizedStrict id="support-entity-table-cell-name-reg-no">
                                <Typography className={classes.entityNameCellSubtitle}>Reg no.:</Typography>
                            </LocalizedStrict>
                            <Typography className={classes.entityNameCellSubtitle}>
                                {row.original.caseNumber}
                            </Typography>
                        </>
                    )}

                    {row.original.isAgreementOwner && row.original?.caseNumber && (
                        <FontAwesomeIcon className={classes.entityNameCellSubtitleIcon} icon={faCircle} />
                    )}

                    {row.original.isAgreementOwner && (
                        <LocalizedStrict id="support-entity-table-cell-name-agreement-owner">
                            <Typography className={classes.entityNameCellSubtitle}>Agreement owner</Typography>
                        </LocalizedStrict>
                    )}
                </Stack>
            </Stack>
        </Box>
    )
}
